import { useSearchParams } from 'react-router-dom';

import { isAllRegionsChoice } from '../../primitives/scope/region-param';
import { useOwnRegions } from '../../primitives/scope/use-own-regions';

import { OVERVIEW_SCOPE_PARAM } from './overview-all-regions';
import { useAllRegionsOverview } from './overview-api';
import { overviewHrefFor } from './overview-path';

export interface OverviewHome {
  /** Not decided yet. Show the spinner, never national data. */
  pending: boolean;
  /** Where to send the viewer, or null to stay on All regions. */
  to: string | null;
}

/**
 * Where the Overview root sends a viewer.
 *
 * `/admin/overview` is the landing page. A viewer without read:all who has
 * assigned regions is sent to their first one (the shallowest, as the other
 * dashboards pick it). An admin, a viewer with no regions, and anyone who chose
 * All regions on purpose (`?scope=all`) stay where they are.
 *
 * The destination comes from Overview's OWN rows: its address is the ancestor
 * path of name slugs, which is not the region's `slug` column. Nothing is
 * decided until the user, the region list and those rows have all arrived.
 */
export function useOverviewHomeRedirect(): OverviewHome {
  const [params] = useSearchParams();
  const { pending: ownPending, own } = useOwnRegions();
  const { data, isLoading } = useAllRegionsOverview();

  if (isAllRegionsChoice(params.get(OVERVIEW_SCOPE_PARAM))) return { pending: false, to: null };
  if (ownPending) return { pending: true, to: null };
  if (own.length === 0) return { pending: false, to: null };
  if (isLoading) return { pending: true, to: null };

  const row = data?.regions.find((r) => r.id === own[0].id);
  return { pending: false, to: row ? overviewHrefFor(row.path) : null };
}
